<template>
	<div>
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/billing/">Billing & Payments</router-link>
		</div>
		<h3>Billing & Payments <span>Overview</span></h3>
		<notification v-if="user.permissions && user.permissions.includes('team-finance') && !demo.isDemo && team.plan=='pro'" type="balance"></notification>
		<div v-if="user.permissions && user.permissions.includes('team-finance')">
			<h4 style="margin-top: 0">Team Account Overview</h4>
			<table id="balance-overview"  class="worksends-table">
				<tbody>
				<tr class="team-resources">
					<td class="desc">
						<h5>Team Resources</h5>
						Your team's own resources that your team has added to its account.
					</td>
					<td class="amount">{{ team.balance | toCurrency }}</td>
					<td class="actions"><div class="ws-button" @click="modals.billingTopUpModal = true">TOP UP</div></td>
				</tr>
				<tr class="team-credit-available">
					<td class="desc">
						<h5>Team Credit Available</h5>
						The credit overdaft that your team is allowed to spend. Your team's total limit is {{ team.credit_limit | toCurrency }}.<br />If you would like to increase your team's credit limit, please <a href="#" @click="modals.contactModal = true" >contact us</a>.
					</td>
					<td class="amount">{{ team.credit_available | toCurrency }}</b><div class="out-of">/ {{ team.credit_limit | toCurrency }}</div></td>
					<td class="actions"><div class="ws-button ws-button-secondary" @click="modals.billingTopUpModal = true">REPAY</div></td>
				</tr>
				<tr class="total-available-to-spend">
					<td class="desc">
						<h5>Total Available To Spend</h5>
						Total sum of all resources available to your team.
					</td>
					<td class="amount"><b>{{ team.total_available | toCurrency }}</b></td>
					<td class="actions">&nbsp;</td>
				</tr>
				</tbody>
			</table>
			<div id="billing-actions" class="tool-actions">
				<a class="ws-button" @click="modals.billingTopUpModal = true">Top Up Team Account</a>
				<a class="ws-button ws-button-secondary" href="billing/payment-documents">View Team Payment Documents</a>
			</div>
		</div>

		<div v-if="user.permissions && !user.permissions.includes('team-finance')">
			<div class="note error">You don't have permissions to view your team's credit balance operation.</div>
		</div>

		<div v-if="index.data.length && user.permissions.includes('team-finance')">
			<h4>Recent Team Balance Transactions</h4>
			<table id="transaction-history" class="worksends-table">
				<thead>
				<tr>
					<th class="field-id">ID</th>
					<th class="field-date">Date</th>
					<th class="field-type">Type</th>
					<th class="field-description">Description</th>
					<th class="field-campaign">Gift Campaign & Option</th>
					<th class="field-product">Product</th>
					<th class="field-price-exvat">Price (ex. VAT)</th>
					<th class="field-price">Price (inc. VAT)</th>
					<th class="field-amount">Amount Charged</th>
					<th class="field-balance">Balance</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in index.data" :data-type="item.type" :class="rowClasses(item)">
					<td class="field-id" data-label="ID"><div class="value">#{{ item.transaction_id }}</div></td>
					<td class="field-date" data-label="Date"><div class="value"><small>{{ item.date }}</small></div></td>
					<td class="field-type" data-label="Type"><div class="value">{{ item.type}}</div></td>
					<td class="field-description" data-label="Description"><div class="value"><b>{{ item.description }}</b></div><div v-if="item.reverted_at" class="reverted-text">Reverted {{ item.reverted_at }}</div></td>
					<td class="field-campaign" data-label="Gift Campaign & Option">
						<div class="value" v-if="item.campaign"><b><a :href="'/campaigns/' + item.campaign.id">{{ item.campaign.name }}</a></b> / {{ item.option.name }}</div>
						<div class="value" v-else-if="item.product"><i>Marketplace</i></div>
					</td>
					<td class="field-product" data-label="Product"><div class="value" v-if="item.product">{{ item.product.name }}</div></td>
					<td class="field-price-exvat" data-label="Price (ex. VAT)"><div class="value" v-if="item.price_ex_vat">{{ item.price_ex_vat | toCurrency }}</div></td>
					<td class="field-price" data-label="Price (inc. VAT)"><div class="value" v-if="item.price">{{ item.price | toCurrency }}</div></td>
					<td class="field-amount" data-label="Amount Charged"><div class="value"><b>{{ positiveAmount(item.amount) | toCurrency }}</b></div></td>
					<td class="field-balance" data-label="Balance"><div class="value">{{ item.balance_live | toCurrency }}</div></td>
				</tr>
				</tbody>
			</table>

			<div v-if="index.meta && parseInt(index.meta.total) > 10" class="ws-table-meta">
				<div class="ws-table-sum">Showing last {{ index.data.length }} out of total {{ index.meta ? index.meta.total : 0 }} transactions. Click to the right to see all transactions.</div>
				<div class="ws-table-navigation"></div>
				<div class="ws-table-pagination">
					<router-link class="ws-button small" to="/billing/transaction-history">View All Team Balance Transactions</router-link>
				</div>
			</div>
		</div>

		<div v-if="directPaymentsIndex.data.length">
			<h4>Recent Direct Payment Transactions</h4>
			<table id="transaction-history" class="worksends-table">
				<thead>
				<tr>
					<th class="field-id">ID</th>
					<th class="field-date">Date</th>
					<th class="field-type">Type</th>
					<th class="field-description">Description</th>
					<th class="field-campaign">Gift Campaign & Option</th>
					<th class="field-product">Product</th>
					<th class="field-price-exvat">Price (ex. VAT)</th>
					<th class="field-price">Price (inc. VAT)</th>
					<th class="field-amount">Amount Charged</th>
					<th class="field-payment-method">Payment Method</th>
					<th class="field-balance">Balance</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in directPaymentsIndex.data" :data-type="item.type" :class="rowClasses(item)">
					<td class="field-id" ><div class="value">#{{ item.transaction_id }}</div></td>
					<td class="field-date" ><div class="value"><small>{{ item.date }}</small></div></td>
					<td class="field-type" ><div class="value">{{ item.type}}</div></td>
					<td class="field-description" ><div class="value"><b>{{ item.description }}</b></div><div v-if="item.reverted_at" class="reverted-text">Reverted {{ item.reverted_at }}</div></td>
					<td class="field-campaign" >
						<div class="value" v-if="item.campaign"><b><a :href="'/campaigns/' + item.campaign.id">{{ item.campaign.name }}</a></b> / {{ item.option.name }}</div>
						<div class="value" v-else-if="item.product"><i>Marketplace</i></div>
					</td>
					<td class="field-product" ><div class="value" v-if="item.product">{{ item.product.name }}</div></td>
					<td class="field-price-exvat"><div class="value" v-if="item.price_ex_vat">{{ item.price_ex_vat | toCurrency }}</div></td>
					<td class="field-price"><div class="value" v-if="item.price">{{ item.price | toCurrency }}</div></td>
					<td class="field-amount"><div class="value"><b>{{ positiveAmount(item.amount) | toCurrency }}</b></div></td>
					<td class="field-payment-method"><div class="value">{{ item.payment_method }}</div></td>
					<td class="field-balance"><div class="value">{{ item.balance }}</div></td>
				</tr>
				</tbody>
			</table>

			<div v-if="directPaymentsIndex.meta && parseInt(directPaymentsIndex.meta.total) > 10" class="ws-table-meta">
				<div class="ws-table-sum">Showing last {{ directPaymentsIndex.data.length }} out of total {{ directPaymentsIndex.meta ? directPaymentsIndex.meta.total : 0 }} transactions. Click to the right to see all transactions.</div>
				<div class="ws-table-navigation"></div>
				<div class="ws-table-pagination">
					<router-link class="ws-button small" to="/billing/transaction-history-direct">View All Direct Payment Transactions</router-link>
				</div>
			</div>
		</div>


		<billing-top-up-modal v-if="modals.billingTopUpModal" :team-id="team.id"></billing-top-up-modal>
	</div>
</template>

<script>
import BillingTopUpModal from '@/pages/billing/BillingTopUpModal';

export default {
	description: "BillingPaymentsPage",
	components: {BillingTopUpModal},
	data() {
		return {
			dispatch: [],
		}
	},
	methods: {
		async fetchData() {
			if (this.user.permissions.includes('team-finance')) this.dispatchWaitAndNotify('fetchRecentTransactions', null, false, true);
			console.log(this.user);
			this.dispatchWaitAndNotify('fetchRecentDirectTransactions', null, false, true);
		},
		rowClasses(item) {
			let classes = [];
			if (item.amount === 0) classes.push('no-charge');
			if (item.reverted_at) classes.push('reverted');
			return classes.join(' ');
		},
		positiveAmount(amount) {
			if (amount > 0) return amount;
			else return 0 - amount;
		}
	},
	async created() {
		await this.fetchData();
	},
	computed: {
		user() {
			return this.$store.state.currentUser;
		},
		index() {
			return this.$store.state.transaction.index;
		},
		directPaymentsIndex() {
			return this.$store.state.transaction.directPaymentsIndex;
		},
		team() {
			return this.$store.state.team.detail;
		},
		modals() {
			return this.$store.state.modals;
		},
		demo() {
			return this.$store.state.demo;
		}
	},
}
</script>

<style scoped>

</style>
